import {UPDATE_ACTIVATION_DATA} from '../actions/actionTypes';

const initialState = {
    active: false
};

export default (state = initialState, {type, ...payload}) => {
    switch (type) {
        case UPDATE_ACTIVATION_DATA: {
            const {activationData} = payload;

            return {...state, ...activationData};
        }

        default: {
            return state;
        }
    }
};
